import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const location = useLocation();

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  // 获取当前路径
  const currentPath = location.pathname;

  // 导航项配置
  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/products', label: 'Products' },
    { path: '/news', label: 'News' },
    { path: '/contact', label: 'Contact' }
  ];

  // 生成导航项样式
  const getNavItemClass = (path) => {
    // 产品详情页也高亮Products导航项
    if (path === '/products' && currentPath.startsWith('/product/')) {
      return 'text-[#003e64] font-bold transition-colors duration-200';
    }
    // 新闻详情页也高亮News导航项
    if (path === '/news' && currentPath.startsWith('/news/')) {
      return 'text-[#003e64] font-bold transition-colors duration-200';
    }
    return currentPath === path 
      ? 'text-[#003e64] font-bold transition-colors duration-200' 
      : 'text-[#5e5e5e] hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors duration-200';
  };

  return (
    <>
      {/* Header */}
      <header className="fixed top-0 w-full h-[60px] z-50 bg-white dark:bg-slate-900 flex items-center px-4 w-full">
        <div className="flex items-center gap-4 md:gap-16">
          <span 
            className="material-symbols-outlined text-[#1a5681] cursor-pointer md:hidden" 
            data-icon="menu"
            onClick={toggleDrawer}
          >
            {isDrawerOpen ? 'close' : 'menu'}
          </span>
          <span className="text-xl font-bold tracking-tight text-[#1a5681]">SILANOL</span>
          <nav className="hidden md:flex gap-8 items-center">
            {navItems.map((item) => (
              <Link 
                key={item.path}
                className={`text-xs font-bold Public Sans uppercase tracking-wider ${getNavItemClass(item.path)}`}
                to={item.path}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      </header>

      {/* Mobile Drawer */}
      <div 
        className={`fixed top-0 left-0 h-full w-64 bg-white dark:bg-slate-900 border-r border-gray-200 dark:border-gray-800 z-40 transition-transform duration-300 ease-in-out ${
          isDrawerOpen ? 'transform translate-x-0' : 'transform -translate-x-full'
        } md:hidden`}
      >
        <div className="p-4 border-b border-gray-200 dark:border-gray-800">
          <div className="flex items-center justify-between">
            <span className="text-xl font-bold tracking-tight text-[#1a5681]">SILANOL</span>
            <span 
              className="material-symbols-outlined text-[#1a5681] cursor-pointer"
              onClick={toggleDrawer}
            >
              close
            </span>
          </div>
        </div>
        <nav className="p-4">
          <ul className="space-y-4">
            {navItems.map((item) => (
              <li key={item.path}>
                <Link 
                  className={`block text-sm font-bold Public Sans uppercase tracking-wider py-2 ${getNavItemClass(item.path)}`}
                  to={item.path}
                  onClick={toggleDrawer}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      {/* Overlay */}
      {isDrawerOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden"
          onClick={toggleDrawer}
        ></div>
      )}
    </>
  );
};

export default Navbar;